<div *ngIf="homeInf.instagramPostChart && homeInf.instagramPostChart.content.length > 0" class="who-we-are-area pt-100 pb-70" >
  <div class="container">
    <div class="section-title">
      <h4>TopOfThePosts</h4>
      <h2>Post di successo di <span>Instagram</span></h2>
      <p>Le prime tre posizioni della settimana dei post di maggior successo di Instagram.</p>
    </div>
    <div class="row" *ngIf="isChartCompleted">
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div data-aos="fade-up" data-aos-delay="1000" data-aos-duration="1500">
          <div class="single-chart-box">
            <div class="image" *ngIf="firstInstagramPostImageUrl != ''">
              <i class="shadow rounded-circle fa-solid fa-2x fa-medal overlay-position" style="color: goldenrod"></i>
              <img [src]=firstInstagramPostImageUrl height="416" alt="">
            </div>
            <div class="content">
              <a href="#" target="_blank">
                <h3 class="title">{{firstInstagram.instagramPostDTO.caption.length > 100 ? firstInstagram.instagramPostDTO.caption.substring(0, 100) + "..." : firstInstagram.instagramPostDTO.caption}}</h3>
              </a>
              <span class="post">Like: {{firstInstagram.instagramPostDTO.likesCount}}</span>
            </div>
            <div class="social">
              <ul>
                <li>
                  <div class="chart-info-influencer">
                    <h3>{{firstInstagram.instagramPostDTO.influencerDTO.username}}</h3>
                    <a href="#" target="_blank"><span>{{firstInstagram.instagramPostDTO.influencerDTO.nickName}}</span></a>
                    <a href="#" target="_blank"><img [src]=firstInstagramInfluencerImageUrl
                                                     alt="{{firstInstagram.instagramPostDTO.influencerDTO.nickName}}"
                                                     class="shadow rounded-circle"></a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div data-aos="fade-up" data-aos-delay="500" data-aos-duration="1500">
          <div class="single-chart-box">
            <div class="image" *ngIf="secondInstagramPostImageUrl != ''">
              <i class="shadow rounded-circle fa-solid fa-2x fa-medal overlay-position" style="color: darkgray"></i>
              <img [src]=secondInstagramPostImageUrl height="416" alt="">
            </div>
            <div class="content">
              <a href="#" target="_blank">
                <h3 class="title">{{secondInstagram.instagramPostDTO && secondInstagram.instagramPostDTO.caption.length > 100 ? secondInstagram.instagramPostDTO.caption.substring(0, 100) + "..." : secondInstagram.instagramPostDTO.caption}}</h3>
              </a>
              <span class="post">Like: {{secondInstagram.instagramPostDTO.likesCount}}</span>
            </div>
            <div class="social">
              <ul>
                <li>
                  <div class="chart-info-influencer">
                    <h3>{{secondInstagram.instagramPostDTO.influencerDTO.username}}</h3>
                    <a href="#" target="_blank"><span>{{secondInstagram.instagramPostDTO.influencerDTO.nickName}}</span></a>
                    <a href="#" target="_blank"><img alt="{{secondInstagram.instagramPostDTO.influencerDTO.nickName}}"
                                                     [src]=secondInstagramInfluencerImageUrl
                                                     class="shadow rounded-circle"></a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div data-aos="fade-up" data-aos-duration="1500">
          <div class="single-chart-box">
            <div class="image" *ngIf="thirdInstagramPostImageUrl != ''">
              <i class="shadow rounded-circle fa-solid fa-2x fa-medal overlay-position" style="color: saddlebrown"></i>
              <img [src]=thirdInstagramPostImageUrl height="416" alt="">
            </div>
            <div class="content">
              <a href="#" target="_blank">
                <h3 class="title">{{thirdInstagram.instagramPostDTO && thirdInstagram.instagramPostDTO.caption.length > 100 ? thirdInstagram.instagramPostDTO.caption.substring(0, 100) + "..." : thirdInstagram.instagramPostDTO.caption}}</h3>
              </a>
              <span class="post">Like: {{thirdInstagram.instagramPostDTO.likesCount}}</span>
            </div>
            <div class="social">
              <ul>
                <li>
                  <div class="chart-info-influencer">
                    <h3>{{thirdInstagram.instagramPostDTO.influencerDTO.username}}</h3>
                    <a href="#" target="_blank"><span>{{thirdInstagram.instagramPostDTO.influencerDTO.nickName}}</span></a>
                    <a href="#" target="_blank"><img alt="{{thirdInstagram.instagramPostDTO.influencerDTO.nickName}}"
                                                     [src]=thirdInstagramInfluencerImageUrl
                                                     class="shadow rounded-circle"></a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="shape2"><img alt="image" src="assets/img/shape1.png"></div>
</div>

<div *ngIf="homeInf.tikTokPostChart && homeInf.tikTokPostChart.content.length > 0" class="who-we-are-area sfondo-tiktok pt-100 pb-70">
  <div class="container">
    <div class="section-title">
      <h4>I primi della settimana</h4>
      <h2>Video più popolari di <span>TikTok</span></h2>
      <p>Le prime tre posizioni della settimana dei video di maggior successo di TikTok.</p>
    </div>
    <div class="row" *ngIf="isChartCompleted">
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div data-aos="fade-up" data-aos-delay="1000" data-aos-duration="1500">
          <div class="single-chart-box">
            <div class="image" *ngIf="firstTikTokPostImageUrl != ''">
              <i class="shadow rounded-circle fa-solid fa-2x fa-medal overlay-position" style="color: goldenrod"></i>
              <img [src]=firstTikTokPostImageUrl height="416" alt="">
            </div>
            <div class="content">
              <a href="#" target="_blank">
                <h3 class="title">{{firstTikTok.tikTokPostDTO && firstTikTok.tikTokPostDTO.title.length > 100 ? firstTikTok.tikTokPostDTO.title.substring(0, 100) + "..." : firstTikTok.tikTokPostDTO.title}}</h3>
              </a>
              <span class="post">Hearts: {{firstTikTok.tikTokPostDTO.heartsCount}}</span>
            </div>
            <div class="social">
              <ul>
                <li>
                  <div class="chart-info-influencer">
                    <h3>{{firstTikTok.tikTokPostDTO.influencerDTO.username}}</h3>
                    <a href="#" target="_blank"><span>{{firstTikTok.tikTokPostDTO.influencerDTO.nickName}}</span></a>
                    <a href="#" target="_blank"><img [src]=firstTikTokInfluencerImageUrl
                                                     alt="{{firstTikTok.tikTokPostDTO.influencerDTO.nickName}}"
                                                     class="shadow rounded-circle"></a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div data-aos="fade-up" data-aos-delay="500" data-aos-duration="1500">
          <div class="single-chart-box">
            <div class="image">
              <i class="shadow rounded-circle fa-solid fa-2x fa-medal overlay-position" style="color: darkgray"></i>
              <img [src]=secondTikTokPostImageUrl height="416" alt="">
            </div>
            <div class="content">
              <a href="#" target="_blank">
                <h3 class="title">{{secondTikTok.tikTokPostDTO && secondTikTok.tikTokPostDTO.title.length > 100 ? secondTikTok.tikTokPostDTO.title.substring(0, 100) + "..." : secondTikTok.tikTokPostDTO.title}}</h3>
              </a>
              <span class="post">Hearts: {{secondTikTok.tikTokPostDTO.heartsCount}}</span>
            </div>
            <div class="social">
              <ul>
                <li>
                  <div class="chart-info-influencer">
                    <h3>{{secondTikTok.tikTokPostDTO.influencerDTO.username}}</h3>
                    <a href="#" target="_blank"><span>{{secondTikTok.tikTokPostDTO.influencerDTO.nickName}}</span></a>
                    <a href="#" target="_blank"><img alt="{{secondTikTok.tikTokPostDTO.influencerDTO.nickName}}"
                                                     [src]=secondTikTokInfluencerImageUrl
                                                     class="shadow rounded-circle"></a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-6">
        <div data-aos="fade-up" data-aos-duration="1500">
          <div class="single-chart-box">
            <div class="image">
              <i class="shadow rounded-circle fa-solid fa-2x fa-medal overlay-position" style="color: saddlebrown"></i>
              <img [src]=thirdTikTokPostImageUrl height="416" alt="">
            </div>
            <div class="content">
              <a href="#" target="_blank">
                <h3 class="title">{{thirdTikTok.tikTokPostDTO && thirdTikTok.tikTokPostDTO.title.length > 100 ? thirdTikTok.tikTokPostDTO.title.substring(0, 100) + "..." : thirdTikTok.tikTokPostDTO.title}}</h3>
              </a>
              <span class="post">Like: {{thirdTikTok.tikTokPostDTO.heartsCount}}</span>
            </div>
            <div class="social">
              <ul>
                <li>
                  <div class="chart-info-influencer">
                    <h3>{{thirdTikTok.tikTokPostDTO.influencerDTO.username}}</h3>
                    <a href="#" target="_blank"><span>{{thirdTikTok.tikTokPostDTO.influencerDTO.nickName}}</span></a>
                    <a href="#" target="_blank"><img alt="{{thirdTikTok.tikTokPostDTO.influencerDTO.nickName}}"
                                                     [src]=thirdTikTokInfluencerImageUrl
                                                     class="shadow rounded-circle"></a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
